var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVigyanVrikshQueBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.robotics0{fill:none;stroke:currentcolor;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "robotics0",
    d: "M58,85c5,2.1,11,3.2,12.8,3.5c0.3,0.1,0.6,0.1,1,0.1c4.6,0.2,8.5-3.5,8.4-8.2c0,0,0.1-6.9,0.5-11.6c0.2-2.4,2.3-4.3,4.7-4.3l0,0c3.4,0,5.6-3.7,4-6.7c-1.3-2.4-2.8-5-3.8-6.7c-1.4-2.4-2.5-5-2.9-7.8c-0.2-1.5-0.3-3.5-0.3-4.7H10.1c0,0-0.2,3.2-0.2,4.5c0,10,4,19,10.6,25.5c5.7,5.7,6.9,13.4,6.9,21.4v0.4"
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "robotics0",
    points: "62,91.8 60.5,97.3 25.4,97.3"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "robotics0",
    d: "M63.4,32c-1.9-7.6-8.8-13.2-16.9-13.2c-8.2,0-15,5.6-16.9,13.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "robotics0",
    d: "M80,32.5l-3-1.6c-2-1.1-3.6-2.9-4.5-5c0,0,0,0,0-0.1c-0.9-2.2-1-4.5-0.3-6.7l1-3.3l-5.7-5.8l-3.3,1c-2.2,0.7-4.6,0.5-6.7-0.4c0,0,0,0-0.1,0c-2.1-0.9-3.9-2.5-5-4.5l-1.6-3l-8.1-0.1l-1.6,3c-1.1,2-2.9,3.6-5,4.5c0,0,0,0-0.1,0c-2.2,0.9-4.5,1-6.7,0.3l-3.3-1l-5.8,5.7l1,3.3c0.7,2.2,0.5,4.6-0.4,6.7c0,0,0,0,0,0.1c-0.9,2.1-2.5,3.9-4.5,5L13,32"
  })), /*#__PURE__*/React.createElement("line", {
    className: "robotics0",
    x1: 25.9,
    y1: 38.5,
    x2: 25.9,
    y2: 49.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "robotics0",
    x1: 40.5,
    y1: 38.5,
    x2: 40.5,
    y2: 57.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "robotics0",
    x1: 55.2,
    y1: 38.5,
    x2: 55.2,
    y2: 49.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "robotics0",
    x1: 69.8,
    y1: 38.5,
    x2: 69.8,
    y2: 57.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "robotics0",
    d: "M25.9,49.6c-2.3,0-4.1,1.8-4.1,4.1c0,2.3,1.8,4.1,4.1,4.1c2.3,0,4.1-1.8,4.1-4.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "robotics0",
    d: "M55.2,49.6c-2.3,0-4.1,1.8-4.1,4.1c0,2.3,1.8,4.1,4.1,4.1c2.3,0,4.1-1.8,4.1-4.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "robotics0",
    d: "M40.5,57.2c-2.3,0-4.1,1.8-4.1,4.1c0,2.3,1.8,4.1,4.1,4.1c2.3,0,4.1-1.8,4.1-4.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "robotics0",
    d: "M69.8,57.2c-2.3,0-4.1,1.8-4.1,4.1c0,2.3,1.8,4.1,4.1,4.1s4.1-1.8,4.1-4.1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVigyanVrikshQueBank);
export default __webpack_public_path__ + "static/media/vigyan-vriksh-que-bank.5be4ed9289fa9261780638580980a2ce.svg";
export { ForwardRef as ReactComponent };